import React, { useEffect, useMemo, useState } from 'react';
import cx from 'classnames';

import { Property } from 'components/Editor/components/properties';

import { PersonalizationSetFilterSummary } from './PersonalizationSetFilterSummary';
import { PersonalizationSetsPanel } from './PersonalizationSetsPanel';
import { PersonalizationShowSelectedContext } from './PersonalizationShowSelectedContext';

import brandkitStyles from 'pages/settings/brandKit/components/brandkit.components.module.scss';
import styles from './personalization.module.scss';

export const PersonalizationWorkspace = ({
  sets,
  activeSetId,
  loading = false,
  onActiveSetChange,
  onSetsChange,
  dynamic = false,
  canSelectAssets = true,
  children,
  footer,
}) => {
  const activeSet = useMemo(
    () => sets.find((set) => set.clientId === activeSetId),
    [sets, activeSetId],
  );

  const canUseShowSelectedToggle = Boolean(activeSet) && !loading;

  const [showSelectedAssetsOnly, setShowSelectedAssetsOnly] = useState(false);

  useEffect(() => {
    setShowSelectedAssetsOnly(false);
  }, [activeSetId]);

  const showSelectedAssetsOnlyEffective =
    canUseShowSelectedToggle && showSelectedAssetsOnly;

  return (
    <div className={styles.workspace}>
      <div className={styles.sidePanelColumn}>
        <PersonalizationSetsPanel
          sets={sets}
          activeSetId={activeSetId}
          loading={loading}
          onActiveSetChange={onActiveSetChange}
          onSetsChange={onSetsChange}
          dynamic={dynamic}
        />
      </div>
      <div className={styles.gridColumn}>
        <h2 className={styles.subheading}>Create personalization</h2>
        <PersonalizationSetFilterSummary activeSet={activeSet} dynamic={dynamic} />
        <div
          className={cx(styles.showSelectedAssetsToggle, brandkitStyles.toggleWrapper, {
            [styles.showSelectedAssetsToggleDisabled]: !canUseShowSelectedToggle,
          })}
          onClick={() => {
            if (!canUseShowSelectedToggle) return;
            setShowSelectedAssetsOnly((prev) => !prev);
          }}
          role="presentation"
        >
          <label className={cx(styles.showSelectedAssetsToggleLabel, brandkitStyles.brandElemenLabel)}>
            Show selected assets
          </label>
          <Property.Switch
            id="personalization-show-selected-assets"
            title=""
            value={showSelectedAssetsOnlyEffective}
            disabled={!canUseShowSelectedToggle}
          />
        </div>
        <PersonalizationShowSelectedContext.Provider value={showSelectedAssetsOnlyEffective}>
          <div
            className={cx(
              styles.assetGridArea,
              !loading && !canSelectAssets && styles.assetGridLocked,
            )}
          >
            {children}
          </div>
        </PersonalizationShowSelectedContext.Provider>
        {footer ? <div className={styles.assetColumnFooter}>{footer}</div> : null}
      </div>
    </div>
  );
};
